// Core module
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * Personal-information component
 */
@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
})
export class PrivacyComponent {

  /**
   * Life cycle method
   * @param authService AuthService
   * @param fb FormBuilder
   */
  constructor(
    private router: Router
  ) { 
  }

  close(): void {
    this.router.navigate([`/`]);
  }
}
